export default __webpack_public_path__ + "static/media/mobile-rotate-rotation.06243905.png";